import { useId } from 'react';

/** An accessible dial: a range input styled as a knob. Keyboard and screen readers get the native range. */
export function Dial({ label, value, onChange, min = 0, max = 1, step = 0.01, format }: {
  label: string; value: number; onChange: (v: number) => void; min?: number; max?: number; step?: number; format?: (v: number) => string;
}) {
  const id = useId();
  const v = (value - min) / (max - min);
  return (
    <div className="dial">
      <div className="dial__face" style={{ ['--v' as string]: v }}>
        <span className="dial__needle" aria-hidden="true" />
        <input id={id} type="range" min={min} max={max} step={step} value={value} aria-label={label}
          onChange={(e) => onChange(Number(e.target.value))} />
      </div>
      <label htmlFor={id} className="dial__label">{label}</label>
      <span className="dial__value">{format ? format(value) : `${Math.round(v * 100)}%`}</span>
    </div>
  );
}
